import React from 'react';
import * as S from './References.styles';
import { FacebookOutlined, GithubOutlined, LinkedinOutlined, TwitterOutlined } from '@ant-design/icons';

export const References: React.FC = () => {
  return (
    <S.ReferencesWrapper>
      <S.Text>
        Made by{' '}
        <a href="https://ksoft.lk/" target="_blank" rel="noreferrer">
          K-SOFT{' '}
        </a>
        in 2023 &copy;. 
      </S.Text>
    </S.ReferencesWrapper>
  );
};
